import { create } from 'zustand';
import type { SessionUser } from '@dgm/shared';
import { api } from './api.js';

/**
 * Admin auth store. Same cookie-based session as the user app, but the admin
 * portal additionally requires the OperatorAdmins group — a non-operator who
 * authenticates still lands in the `forbidden` state and cannot see anything.
 */
interface AdminAuthState {
  user: SessionUser | null;
  status: 'loading' | 'operator' | 'forbidden' | 'anonymous';
  hydrate: () => Promise<void>;
  setUser: (user: SessionUser | null) => void;
  logout: () => Promise<void>;
}

export const useAuth = create<AdminAuthState>((set) => ({
  user: null,
  status: 'loading',
  hydrate: async () => {
    try {
      const user = await api.get<SessionUser>('/me');
      set({ user, status: user.isOperatorAdmin ? 'operator' : 'forbidden' });
    } catch {
      set({ user: null, status: 'anonymous' });
    }
  },
  setUser: (user) =>
    set({
      user,
      status: user ? (user.isOperatorAdmin ? 'operator' : 'forbidden') : 'anonymous',
    }),
  logout: async () => {
    await api.post('/auth/logout').catch(() => undefined);
    set({ user: null, status: 'anonymous' });
  },
}));
